import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/HomePage';
import {useState, useEffect} from 'react';
import Kvkk from './pages/KvkkPage';
import About from './pages/AboutPage';
import CompanyInfo from './pages/CompanyInfoPage';
import HowToSendMoney from './pages/HowToSendMoneyPage';
import Reservation from './pages/ReservationPage';
import './css/page.css'

function App() {
  const [theme, setTheme] = useState("");

  useEffect(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const theme = urlParams.get('theme')?.toLowerCase();
      document.body.setAttribute("class",theme);
      localStorage.setItem("tema",theme)
      setTheme(theme)
  }, []);

  return (
    <>
      {
        (theme!="")
        ?
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/kvkk" element={<Kvkk />} />
          <Route path="/about" element={<About />} />
          <Route path="/company-info" element={<CompanyInfo />} />
          <Route path="/how-to-send-money" element={<HowToSendMoney />} />
          <Route path="/reservation" element={<Reservation />} /> */}
        </Routes>
        :
        null
      }
    </>
  );
}

export default App;
